import * as React from 'react';
import { useEffect, useRef } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { Navigate } from 'react-router-dom';
import useRedirectTo from '../../helpers/location';
import SplashScreen from '../../components/layout/SplashScreen';

const Login: React.FC = () => {
  const { keycloak, initialized } = useKeycloak();
  const currentLocationState = useRedirectTo();
  const loginTriggered = useRef(false);

  if (currentLocationState?.from.pathname === '/logout') {
    currentLocationState.from.pathname = '/';
  }

  useEffect(() => {
    if (!initialized || !keycloak || keycloak.authenticated) return;
    if (loginTriggered.current) return;
    loginTriggered.current = true;
    keycloak.login({
      redirectUri: `${window.location.origin}${currentLocationState?.from.pathname}`,
    });
  }, [initialized, keycloak, currentLocationState]);

  if (keycloak?.authenticated) {
    return <Navigate to={currentLocationState?.from} />;
  }

  return <SplashScreen />;
};

export default Login;
